import IconProps, { StyledG } from './IconProps';

function EvaluationIcon({ color = 'primary' }: IconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fillRule="nonzero" transform="translate(-615 -875)">
					<path d="M624.999 894.996c-5.522 0-9.999-4.476-9.999-9.998 0-5.522 4.477-9.998 9.999-9.998s9.998 4.476 9.998 9.998c0 5.522-4.476 9.998-9.998 9.998zm0-18.746a8.748 8.748 0 100 17.496 8.748 8.748 0 100-17.496zm4.999 8.748a5 5 0 00-9.999 0h-1.25a6.249 6.249 0 0112.499 0h-1.25zm-5.624 2.5c.006 0 .01.003.015.003l1.732-4.081c.133-.315.535-.496.897-.404.362.091.548.42.414.735l-1.803 4.25c.375.342.62.824.62 1.371a1.875 1.875 0 11-1.875-1.875zm0 2.5a.625.625 0 100-1.25.625.625 0 000 1.25z" />
				</StyledG>
			</g>
		</svg>
	);
}

export default EvaluationIcon;
